import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const setChartsToStore = createAction('setChartsToStore');
export const setFleetsToStore = createAction('setFleetsToStore');
export const setFlyToLocation = createAction('setFlyToLocation');
export const setIdleTimeFilter = createAction('setIdleTimeFilter');
export const cleanFleetMapStore = createAction('cleanFleetMapStore');
export const setEnterpriseFilter = createAction('setEnterpriseFilter');
export const setFlyToLocationValue = createAction('setFlyToLocationValue');
export const setTrailerLoadedFilter = createAction('setTrailerLoadedFilter');
export const setTrailerUnitIdFilter = createAction('setTrailerUnitIdFilter');
export const setGeoFencingLocationTypeFilter = createAction('setGeoFencingLocationTypeFilter');

export const setFleetsLoadedToStore = createAction('setFleetsLoadedToStore');
export const openMapPageFromFleetList = createAction('openMapPageFromFleetList');
export const setGeoFencingLocationToStore = createAction('setGeoFencingLocationToStore');

export const getBranchConfigsByNamesSuccess = createAction('getBranchConfigsByNamesSuccess');
